import React, {useState} from 'react';
import {Route, Switch} from "react-router-dom";
import Services from "../pages/dashboard/services/Services";
import Tickets from "../pages//dashboard/tickets/Tickets";
import Factors from "../pages/dashboard/factors/Factors";
import Index from "../pages/dashboard/dashboard/Index";
import Aside from "./Aside";
import Header from "./Header";
import Toolbar from "./Toolbar";
import Footer from "./Footer";
import AddTicket from "../pages/dashboard/tickets/AddTicket";
import EditProf from "../pages/dashboard/dashboard/EditProf";
import Profile2 from "../pages/dashboard/dashboard/Profile";
import Profile from '../pages/dashboard/profile/Profile';
import ServiceDetail from "../pages/dashboard/services/ServiceDetail2";
import TicketDetail from "../pages/dashboard/tickets/TicketDetail";
import serverIran from "../pages/dashboard/serverIran/serverIran";
import serverEurope from "../pages/dashboard/serverEurope/serverEurope";
import ServerOrder from "../pages/dashboard/serverIran/ServerOrder";
import FactorDetail from "../pages/dashboard/factors/FactorDetail";
import Page404 from "./Page404";
import Card from "../pages/dashboard/serverIran/Card";
import Servers from "../pages/dashboard/servers/Servers";
import ChangePassword from "../pages/dashboard/profile/ChangePassword";
import FactorPrint from "../pages/dashboard/factors/FactorPrint";
import WalletPage from "pages/dashboard/wallet/Wallet";
import FactorPayment from "pages/dashboard/factors/Payment";
import AccessGroup from "pages/dashboard/access_group/index";
import RedirectToService from "pages/RedirectToService";
import UserIsConfirm from "components/alert/UserIsConfirm";
import EmailIsConfirm from "components/alert/EmailIsConfirm";

const Layout = () => {

    const [info, setInfo] = useState("");
    const [currentURL, setCurrentURL] = useState('')
    document.cookie = `is_login=true; path=/; domain=.zaminhost.com`;
    React.useEffect(() => {
        const url = window.location.href;
        setCurrentURL(url)
        // const urlParams = new URLSearchParams(window.location.search);
        // const product = urlParams.get('product');
        // const locale = urlParams.get('locale');
        // ///
        const token = localStorage.getItem('token');
        if (!token) {
            // window.location.pathname = product && locale ? `/login?product=${product}&locale=${locale}` : "/login";
            window.location.pathname = "/login";
        }
        // console.log(currentURL);

        // window.location.pathname = "/";
    }, [])
    return (
      <React.Fragment>
        <Aside />
        <div
          className="wrapper d-flex flex-column flex-row-fluid min-h-100"
          id="kt_wrapper"
        >
          <Header />
          <Toolbar />
          <div className="flex-grow-1" id="kt_content">
            <div id="kt_content_container" className="container-box">
                <UserIsConfirm />
                <EmailIsConfirm />
              <Switch>
                  <Route
                      exact
                      path="/redirect-to-service"
                      render={() => <RedirectToService />}
                  />
                <Route
                  exact
                  path="/card"
                  render={() => <Card />}
                />
                <Route
                  exact
                  path="/card"
                  render={() => <Card />}
                />
                <Route
                  exact
                  path="/servers/:category"
                  render={() => <Servers />}
                />
                <Route exact path="/services" render={() => <Services />} />
                <Route exact path="/tickets" render={() => <Tickets />} />
                <Route exact path="/tickets/add-ticket" component={AddTicket} />
                <Route
                  exact
                  path="/services/server-iran/server-order"
                  component={ServerOrder}
                />
                <Route
                  exact
                  path="/server-europe/server-order"
                  component={ServerOrder}
                />
                <Route
                  exact
                  path="/services/server-iran"
                  component={serverIran}
                />
                <Route exact path="/server-europe" component={serverEurope} />
                <Route exact path="/edit-profile" component={Profile} />
                <Route
                  exact
                  path="/edit-prof"
                  render={() => (
                    <Profile2>
                      <EditProf />
                    </Profile2>
                  )}
                />
                <Route exact path="/wallet" component={WalletPage} />
                <Route
                  exact
                  path="/change-password"
                  component={ChangePassword}
                />
                <Route exact path="/factors" component={Factors} />
                <Route exact path="/factors/factor-detail">
                  <FactorDetail />
                </Route>
                <Route
                  exact
                  path="/factors/payment/:factorId/"
                  component={FactorPayment}
                ></Route>
                <Route
                  exact
                  path="/factors/factor-print-:factorId/"
                  component={FactorPrint}
                ></Route>
                <Route
                  exact
                  path="/services/service-detail"
                  component={ServiceDetail}
                />
                <Route exact path="/tickets/ticket-detail">
                  <TicketDetail />
                </Route>
                <Route exact path="/permission/access-group">
                    <AccessGroup />
                </Route>
                <Route exact path="/" render={() => <Index />} />
                <Route path="*" render={() => <Page404 />} />
              </Switch>
            </div>
          </div>
          <Footer />
        </div>
      </React.Fragment>
    );
};

export default Layout;